require('./ProgramEpisodes_List.scss');

const b = require('app/www/libs/b')('program-episodes-list');

const React = require('react');
const PropTypes = require('prop-types');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const Metrika = require('app/www/libs/client/metrika');
const {buildYStatFromBlock} = require('app/common/libs/streamChannel');

const Button = require('app/www/components/blocks/Button/Button');
const Carousel = require('app/www/components/blocks/Carousel/Carousel');
const Icon = require('app/www/components/blocks/Icon/Icon');
const Tabs = require('app/www/components/blocks/Tabs/Tabs');
const Ua = require('app/www/components/blocks/Ua/Ua');
const Video = require('app/www/components/blocks/Video/Video');

const DEFAULT_DURATION = 0;

const ITEM_PADDINGS = 16;

const SIMPLE_ITEM_WIDTH = 161;
const SIMPLE_HEADER_WIDTH = 630;
const SIMPLE_HEADER_ITEMS = 4;
const SIMPLE_HEADER_VIDEO_HEIGHT = 350;
const SIMPLE_HEADER_VIDEO_WIDTH = 628;

const COMPLEX_ITEM_WIDTH = 162;
const COMPLEX_HEADER_WIDTH = 956;
const COMPLEX_HEADER_ITEMS = 6;
const COMPLEX_HEADER_ITEMS_LAYOUT_LARGE = 4;
const COMPLEX_HEADER_VIDEO_HEIGHT = 446;
const COMPLEX_HEADER_VIDEO_HEIGHT_LAYOUT_LARGE = 388;
const COMPLEX_HEADER_VIDEO_WIDTH = 796;
const COMPLEX_HEADER_VIDEO_WIDTH_LAYOUT_LARGE = '100%';

class ProgramEpisodes_List extends React.PureComponent {
    constructor(props) {
        super(props);

        if (props.hasComplexHeader) {
            this._itemWidth = COMPLEX_ITEM_WIDTH;
            this._itemsPerScroll = COMPLEX_HEADER_ITEMS;
            this._carouselWidth = COMPLEX_HEADER_WIDTH + ITEM_PADDINGS;
            this._scrollWidth = COMPLEX_HEADER_ITEMS * COMPLEX_ITEM_WIDTH;
            this._videoWidth = COMPLEX_HEADER_VIDEO_WIDTH;
            this._videoHeight = COMPLEX_HEADER_VIDEO_HEIGHT;
        } else {
            this._itemWidth = SIMPLE_ITEM_WIDTH;
            this._itemsPerScroll = SIMPLE_HEADER_ITEMS;
            this._carouselWidth = SIMPLE_HEADER_WIDTH + ITEM_PADDINGS;
            this._scrollWidth = SIMPLE_HEADER_ITEMS * SIMPLE_ITEM_WIDTH;
            this._videoWidth = SIMPLE_HEADER_VIDEO_WIDTH;
            this._videoHeight = SIMPLE_HEADER_VIDEO_HEIGHT;
        }

        this._renderItem = this._renderItem.bind(this);
        this._renderItemWithSchema = this._renderItemWithSchema.bind(this);
        this._onTabChange = this._onTabChange.bind(this);
    }

    getSnapshotBeforeUpdate(prevProps) {
        const {hasComplexHeader, isLayoutColumnsLarge} = this.props;

        if (
            hasComplexHeader === prevProps.hasComplexHeader &&
            isLayoutColumnsLarge === prevProps.isLayoutColumnsLarge
        ) {
            return null;
        }

        if (isLayoutColumnsLarge) {
            this._carouselWidth = null;

            if (hasComplexHeader) {
                this._itemsPerScroll = COMPLEX_HEADER_ITEMS_LAYOUT_LARGE;
                this._scrollWidth = COMPLEX_HEADER_ITEMS_LAYOUT_LARGE * COMPLEX_ITEM_WIDTH;
                this._videoWidth = COMPLEX_HEADER_VIDEO_WIDTH_LAYOUT_LARGE;
                this._videoHeight = COMPLEX_HEADER_VIDEO_HEIGHT_LAYOUT_LARGE;
            }
        } else {
            if (hasComplexHeader) {
                this._itemsPerScroll = COMPLEX_HEADER_ITEMS;
                this._scrollWidth = COMPLEX_HEADER_ITEMS * COMPLEX_ITEM_WIDTH;
                this._carouselWidth = COMPLEX_HEADER_WIDTH + ITEM_PADDINGS;
                this._videoWidth = COMPLEX_HEADER_VIDEO_WIDTH;
                this._videoHeight = COMPLEX_HEADER_VIDEO_HEIGHT;
            } else {
                this._carouselWidth = SIMPLE_HEADER_WIDTH + ITEM_PADDINGS;
            }
        }
    }

    componentDidMount() {
        const {
            programId,
            programType,
            programTitle,
            hasMoreThanOneEpisode,
        } = this.props;

        if (hasMoreThanOneEpisode) {
            Metrika.trackParams('VOD', {
                param: 'carousel_show',
                programTitle,
                programType: programType.alias,
                programId,
            });
        }
    }

    render() {
        const {
            i18n,
            episodes,
            tabsItems,
            hasSeasons,
            selectedSeason,
            onSelectEpisode,
            selectedEpisode,
            hasComplexHeader,
            getEpisodeTitles,
            hasMoreThanOneEpisode,
        } = this.props;

        const isPlaying = Boolean(selectedEpisode);

        const carouselProps = {
            mods: {
                episodes: true,
                episodes_complex: hasComplexHeader,
                lists: true,
                dark: hasComplexHeader && isPlaying,
            },
            hasNext: episodes.length > this._itemsPerScroll,
            width: this._carouselWidth,
            scrollWidth: this._scrollWidth,
        };

        if (Ua.isRobot) {
            carouselProps.render = this._renderItemWithSchema;
        } else {
            carouselProps.render = this._renderItem;
            carouselProps.autoLoad = {
                itemsRendered: this._itemsPerScroll * 2,
                itemsRemained: this._itemsPerScroll / 2,
                itemWidth: this._itemWidth,
            };
        }

        const embedUrl = selectedEpisode && selectedEpisode.embedUrl;

        const videoProps = {
            allowFullScreen: true,
            height: this._videoHeight,
            width: this._videoWidth,
            src: embedUrl
                ? `${embedUrl}&${buildYStatFromBlock('programpage', Ua.isTouchPhone)}`
                : '',
        };

        let videoTitle;

        if (isPlaying) {
            const {title, subtitle} = getEpisodeTitles(selectedEpisode);

            videoTitle = `${title ? `${title}. ` : ''}${subtitle ? subtitle : ''}`;
        }

        const buttonCloseProps = {
            className: b('close'),
            onClick: onSelectEpisode(null),
            mods: {
                size: 'l',
                'only-icon': true,
            },
            icon: {
                close: true,
                size: 'l',
            },
        };

        const mods = {
            complex: hasComplexHeader,
            'is-playing': isPlaying,
            'one-episode': !hasMoreThanOneEpisode,
            'with-seasons': hasSeasons,
        };

        const tabsProps = {
            mods: {
                dark: isPlaying,
            },
            items: hasSeasons && tabsItems,
            selectedId: selectedSeason,
            onChange: this._onTabChange,
        };

        return (
            <div className={b(mods)} ref={ref => (this.node = ref)}>
                {isPlaying && hasComplexHeader && (
                    <Button {...buttonCloseProps} />
                )}
                <div className={b('wrapper')}>
                    {isPlaying && (
                        <div className={b('video-wrapper', {'is-playing': isPlaying})}>
                            <Video className={b('video')} {...videoProps} />
                            {hasMoreThanOneEpisode && (
                                <div className={b('video-title')}>{videoTitle}</div>
                            )}
                        </div>
                    )}
                    {hasMoreThanOneEpisode && [
                        <h2 key="title" className={b('title')}>{i18n.get('program-episodes.title')}</h2>,
                        hasSeasons && (
                            <Tabs key="tabs" {...tabsProps} />
                        ),
                        <Carousel key="carousel" {...carouselProps}>
                            {episodes}
                        </Carousel>,
                    ]}
                </div>
            </div>
        );
    }

    /**
     * Render episode for humans
     * @param {Object} episode
     * @private
     */
    _renderItem(episode) {
        const {
            i18n,
            programTitle,
            selectedEpisode,
            onSelectEpisode,
            hasComplexHeader,
            getEpisodeTitles,
        } = this.props;

        const playIconProps = {
            mods: {
                play: true,
                size: 'm',
                dark: hasComplexHeader && Boolean(selectedEpisode),
            },
        };

        const isSelected = episode === selectedEpisode;
        const {title, subtitle} = getEpisodeTitles(episode);

        const titleAttr = this._getAttrTitle(programTitle, subtitle);

        let onClick = null;

        if (!isSelected) {
            onClick = onSelectEpisode(episode);
        }

        return (
            <div
                key={episode.contentId}
                className={b('item', {selected: isSelected})}
                title={titleAttr}
                onClick={onClick}
            >
                <div className={b('item-thumbnail')} style={{backgroundImage: `url(${episode.thumbnail})`}}>
                    {isSelected && (
                        <div className={b('item-playing-now')}>{i18n.get('program-episodes.playing-now')}</div>
                    )}
                    {!isSelected && (
                        <div className={b('item-play-button')}>
                            <Icon {...playIconProps} />
                        </div>
                    )}
                </div>
                <div className={b('item-title')}>{title}</div>
                {Boolean(subtitle) && <div className={b('item-subtitle')}>{subtitle}</div>}
            </div>
        );
    }

    /**
     * Render episode with schema.org markup
     * @param {Object} episode
     * @private
     */
    _renderItemWithSchema(episode) {
        const {
            req,
            canonicalUrl,
            programType,
            programTitle,
            programDuration,
            onSelectEpisode,
            getEpisodeTitles,
        } = this.props;

        const moment = req.lib('moment');

        return this._typeSchemaWrapper(programType, episode, (
            <div className={b('item')}
                onClick={onSelectEpisode(episode)}
                itemProp="video" itemScope itemType="http://schema.org/VideoObject"
                title={this._getAttrTitle(programTitle, getEpisodeTitles(episode).subtitle)}
            >
                <a itemProp="url" href={canonicalUrl} />
                <meta itemProp="name" content={episode.name} />
                <meta itemProp="description" content={episode.description} />
                <meta itemProp="duration" content={moment.lib().duration(episode.duration || programDuration * 60 * 1000 || DEFAULT_DURATION).toISOString()} />
                <meta itemProp="isFamilyFriendly" content={episode.isFamilyFriendly.toString()} />
                <meta itemProp="uploadDate" content={moment.toISO(episode.uploadDate)} />
                <link itemProp="embedUrl" href={episode.embedUrl} />
                <meta itemProp="allowEmbed" content="true" />
                <img itemProp="thumbnailUrl" src={`https:${episode.thumbnail}`} />
                <span itemProp="thumbnail" itemScope itemType="http://schema.org/ImageObject">
                    <img itemProp="contentUrl" src={`https:${episode.thumbnail}`} />
                    <meta itemProp="width" content="400" />
                    <meta itemProp="height" content="300" />
                </span>
            </div>
        ));
    }

    /**
     * Wraps content depending on program type
     * @param {Object} programType
     * @param {Object} episode
     * @param {Object} content
     * @private
     */
    _typeSchemaWrapper(programType, episode, content) {
        const moment = this.props.req.lib('moment');

        if (programType.isFilm) {
            return (
                <div key={episode.contentId} itemScope itemType="http://schema.org/Movie">
                    <meta itemProp="description" content={episode.description} />
                    {content}
                </div>
            );
        } else if (programType.isSerial) {
            return (
                <div key={episode.contentId} itemScope itemType="http://schema.org/TVEpisode">
                    <meta itemProp="description" content={episode.description} />
                    <meta itemProp="dateReleased" content={moment.toISO(episode.date)} />
                    <meta itemProp="datePublished" content={moment.toISO(episode.date)} />
                    <meta itemProp="episodeNumber" content={episode.episodeNumber} />
                    <meta itemProp="partOfSeason" content={episode.seasonNumber} />
                    {content}
                </div>
            );
        }

        return (
            <div key={episode.contentId} itemScope itemType="http://schema.org/TVSeries">
                <meta itemProp="description" content={episode.description} />
                <meta itemProp="dateReleased" content={moment.toISO(episode.date)} />
                <meta itemProp="datePublished" content={moment.toISO(episode.date)} />
                {content}
            </div>
        );
    }

    /**
     * @param {String} programTitle
     * @param {String} subtitle
     * @private
     * @returns {String}
     */
    _getAttrTitle(programTitle, subtitle) {
        const {i18n} = this.props;
        return `${i18n.get('button.broadcasting.title-attr.value', {title: programTitle})} ${subtitle}`;
    }

    /**
     * @private
     */
    _onTabChange(tabId) {
        this.props.onTabChange(tabId);
    }
}

ProgramEpisodes_List.propTypes = {
    tabsItems: PropTypes.array,
    hasSeasons: PropTypes.bool,
    canonicalUrl: PropTypes.string.isRequired,
    hasComplexHeader: PropTypes.bool.isRequired,
    getEpisodeTitles: PropTypes.func.isRequired,
    isLayoutColumnsLarge: PropTypes.bool,
    hasMoreThanOneEpisode: PropTypes.bool.isRequired,
    programId: PropTypes.number.isRequired,
    programTitle: PropTypes.string.isRequired,
    programType: PropTypes.object.isRequired,
    programDuration: PropTypes.number,
    selectedEpisode: PropTypes.object,
    onSelectEpisode: PropTypes.func,
    episodes: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            duration: PropTypes.number,
            embedUrl: PropTypes.string.isRequired,
            contentId: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            uploadDate: PropTypes.number.isRequired,
            description: PropTypes.string.isRequired,
            seasonNumber: PropTypes.number,
            episodeNumber: PropTypes.number,
            isFamilyFriendly: PropTypes.bool.isRequired,
        })
    ),
};

module.exports = withReq(withI18n(ProgramEpisodes_List));
